import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
import { containerSizeMap } from "./Avatar.styles.mjs.mjs";
export const AvatarSkeleton = (props) => {
    const size = containerSizeMap[props.size];
    return React.createElement(SkeletonShape, { variant: "circular", width: size, height: size });
};
//# sourceMappingURL=Avatar.skeleton.mjs.mjs.map